import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
    template: `<h3>Authorization received. Return to the store window to check whether it was saved.</h3>`
})
export class AccountConnectedComponent {
    constructor(private route: ActivatedRoute) {
        this.route.queryParams.subscribe(params => {
            const authCode = params['code'];
            const state = params['state'];
            if (authCode) {
                window.opener?.postMessage({
                    type: 'AUTH_CODE',
                    code: authCode,
                    state
                }, window.location.origin);

                // Close this window after a short delay
                setTimeout(function () {
                    window.close();
                }, 500);
            }
        });
    }
}
